import { describeResource } from '@siteless/resource';
import { doc, getDoc } from 'firebase/firestore';
import { database } from '../config/firebase';
import { thisOscarsYear } from '../config/constants';

export const GlobalPhase = {
  UNKNOWN: 'UNKNOWN',
  BALLOT_OPEN: 'BALLOT_OPEN',
  CEREMONY_START: 'CEREMONY_START',
  CEREMONY_AFTER: 'CEREMONY_AFTER',
  NEXT_YEAR_PREP: 'NEXT_YEAR_PREP',
} as const;

export type GlobalPhaseType = (typeof GlobalPhase)[keyof typeof GlobalPhase];

let GlobalPhaseResource = describeResource<undefined, GlobalPhaseType>(
  'GlobalPhase',
  {
    get: async () => {
      let [currentYearDoc, nextYearDoc] = await Promise.all([
        getDoc(doc(database, 'objective_state', String(thisOscarsYear))),
        getDoc(doc(database, 'objective_state', String(thisOscarsYear + 1))),
      ]);

      let currentYearState = currentYearDoc.data() ?? {};
      let nextYearState = nextYearDoc.data() ?? {};



      if (currentYearState.isBallotReady && !currentYearState.didCeremonyStart) {
        return GlobalPhase.BALLOT_OPEN;
      }

      if (currentYearState.didCeremonyStart && !currentYearState.didCeremonyEnd) {
        return GlobalPhase.CEREMONY_START;
      }

      if (currentYearState.didCeremonyEnd) {
        if (nextYearState.ceremonyDetails?.nominationsAnnouncementAt) {
          return GlobalPhase.NEXT_YEAR_PREP;
        }
        return GlobalPhase.CEREMONY_AFTER;
      }

      return GlobalPhase.UNKNOWN;
    },
  },
);

export default GlobalPhaseResource;